import React, { ReactElement } from 'react';
import styled from '@emotion/styled';




// import BoardQuestItemStatic from './BoardQuestItemStatic';
import BoardQuestItem from './Item/BoardQuestItem';
import { QuestInterface } from '@swivl/swivl-lib';




export const getBackgroundColor = (
  isDraggingOver: boolean,
  isDraggingFrom: boolean,
): string => {
  if (isDraggingOver) {
    return  '#FFF5E2';
  }
//   if (isDraggingFrom) {
//     return colors.QuestAreaDraging;
//   }
  return 'transparent';
};

interface WrapperProps {
  isDraggingOver: boolean;
  isDraggingFrom: boolean;
  isDropDisabled: boolean;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px;
  margin: 4px 4px 8px 4px;
  border-radius: 8px;
  padding-bottom: 0;
  transition:
    background-color 0.2s ease,
    opacity 0.1s ease;
  user-select: none;
  width: 250px;
`;

const scrollContainerHeight = 250;


const DropZone = styled.div`
  /* stop the list collapsing when empty */
  min-height:45px;

  /*
    not relying on the items for a margin-bottom
    as it will collapse when the list is empty
  */
  padding-bottom: 4px;
`;

const ScrollContainer = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  max-height: ${scrollContainerHeight}px;
`;

/* stylelint-disable block-no-empty */
const Container = styled.div``;

/* stylelint-enable */

interface Props {
  quests: QuestInterface[];
  isDraggingAQuest?: boolean;
}

interface InnerBoardQuestListProps {
  quests: QuestInterface[];
}

function InnerBoardQuestList(props: InnerBoardQuestListProps): ReactElement {
  return (
    <>
      {props.quests.map((quest: QuestInterface, index: number) => 
    //   <BoardQuestItem
    //           key={quest.slug}
    //           quest={quest}
    //           isDragging={dragSnapshot.isDragging}
    //           isGroupedOver={Boolean(dragSnapshot.combineTargetFor)}
    //           provided={dragProvided}
    //         />
            <BoardQuestItem
                quest={quest}
                key={quest.slug}
        />

      )}
    </>
  );
}

const InnerBoardQuestListMemo = React.memo<InnerBoardQuestListProps>(InnerBoardQuestList);

interface InnerListProps {  quests: QuestInterface[]; }

function InnerList(props: InnerListProps) {
  const { quests } = props;
  return (
    <Container>
        <InnerBoardQuestListMemo quests={quests} />
    </Container>
  );
}

export default function BoardQuestListStatic(props: Props): ReactElement {
  const {

    quests,
    // useClone,
  } = props;

  
  return (<Wrapper >
 
 
            <InnerList
              quests={quests}
            />
        </Wrapper>
      
  );
}
